import type { StepContentConfig } from '@workspace/core-ts/utils';

const besoinContent: StepContentConfig = {
    mainTitle: {
        site: 'Votre besoin',
        courtier: 'Son besoin',
    },

    protectionQuestion: {
        site: "Souhaitez-vous <strong>être indemnisé en cas d'accident responsable</strong> qui pourrait vous engendrer de <strong>graves blessures, voire même un décès ?</strong>",
        courtier:
            "Votre client souhaite-t-il <strong>être indemnisé en cas d'accident responsable</strong> qui pourrait lui engendrer de <strong>graves blessures, voire même un décès ?</strong>",
    },

    protectionInfoTitle: {
        site: 'Cette garantie vous indemnise :',
        courtier: 'Cette garantie indemnise votre client :',
    },

    protectionInfoDetails: {
        site: "en cas d'invalidité (AIPP ≥ 15%) : jusqu'à 100 000 €<br/>en cas de décès : 15 000 € pour votre conjoint et 3 000 € par enfant mineur.",
        courtier: "en cas d'invalidité (AIPP ≥ 15%) : jusqu'à 100 000 €<br/>en cas de décès : 15 000 € pour le conjoint et 3 000 € par enfant mineur.",
    },
    protectionInfoExplanation: {
        site: "Si vous êtes victime et blessé suite à un accident causé par un tiers, vos blessures seront indemnisées par son assureur.<br/><br/>Mais si vous êtes le responsable ou que vous avez provoqué seul cet accident, les impacts financiers d'une invalidité ou même d'un décès peuvent être importants pour vous et vos proches. Vous pouvez vous assurer pour faire face à ces conséquences financières.<br/><br/>Sachez que tout utilisateur de votre vélo (famille, amis) sera également assuré par cette garantie, ainsi que l'enfant transporté (sur un siège vélo, dans une remorque ou caisse d'un vélo cargo...).",
        courtier:
            "Si votre client est victime et blessé(e) suite à un accident causé par un autre véhicule, ses blessures seront indemnisées par son assureur.<br/><br/>Mais s'il est le responsable ou qu'il a provoqué seul cet accident, les impacts financiers d'une invalidité ou même d'un décès peuvent être importants pour lui et ses proches. Il peut s'assurer pour faire face à ces conséquences financières.<br/><br/>Sachez que tout utilisateur de votre vélo (famille, amis) sera également assuré par cette garantie, ainsi que l'enfant transporté (sur un siège vélo, dans une remorque ou caisse d'un vélo cargo...).",
    },
};

export default besoinContent;